import {Modifier} from '@popperjs/core';

/**
 * Popper modifier, makes popper as wide as reference element
 */
export const createPopperReferenceWideModifier = (): Modifier<any, any> => ({
    name: 'referenceWide',
    enabled: true,
    phase: 'beforeWrite',
    requires: ['computeStyles'],
    fn: ({state}) => {
        const referenceWidth: number = state.rects.reference.width;

        // TODO: Trying to fix cropped autocomplete list for security, we need to text if it's ok
        //  to comment the line below
        // state.styles.popper.width = `${Math.max(state.rects.popper.width, referenceWidth)}px`;

        state.styles['popper'].minWidth = `${referenceWidth}px`;
    },
    effect: ({state}) => {
        const referenceWidth: number = (state.elements.reference as HTMLElement).offsetWidth;

        state.elements.popper.style.boxSizing = 'border-box';
        state.elements.popper.style.minWidth = `${referenceWidth}px`;

        return () => undefined;
    }
});
